import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { takeWhile } from 'rxjs';
import { BaseStyleClassesDirective } from '../../gk-directives';
import { DictionaryField } from '../../gk-dynamic-list/services/dictionary/dictionary.model';
import { PortalId } from '../../utils/portal-id/portal-id.model';
import { RequestModeControlName } from './services/request-mode-form/request-mode-form.model';
import { RequestModeService } from './services/request-mode/request-mode.service';

@Component({
  selector: 'gk-request-mode',
  standalone: false,
  template: `
    <form [formGroup]="formGroup">
      @let requestModeFormControlAlertShouldBeVisible =
        submitted && !isRequestModeFormControlValid();
      <section>
        <div
          class="card mb-4"
          [ngClass]="
            requestModeFormControlAlertShouldBeVisible
              ? 'border-danger border-2'
              : 'card-border-color-from-db'
          "
        >
          <div class="card-header card-header-color-from-db">
            <label class="mb-0" [attr.for]="controlName.RequestMode">
              {{ 'REQUEST_MODE.TITLE' | translate }}
            </label>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <mat-select
                  class="form-select form-select-sm required"
                  [id]="controlName.RequestMode"
                  [attr.name]="controlName.RequestMode"
                  [formControlName]="controlName.RequestMode"
                  [placeholder]="'REQUEST_MODE.CHOOSE_REQUEST_MODE' | translate"
                >
                  @for (requestMode of requestModes; track requestMode.id) {
                    <mat-option [value]="requestMode.id">
                      {{ requestMode.name }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
          </div>
          @if (requestModeFormControlAlertShouldBeVisible) {
            <div class="card-footer">
              <div class="alert alert-danger my-2">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            </div>
          }
        </div>
      </section>
    </form>
  `,
})
export class RequestModeComponent
  extends BaseStyleClassesDirective
  implements OnInit, OnDestroy
{
  private isAlive = true;
  requestModes: DictionaryField[];
  @Input() submitted: boolean;
  @Input() portalId: PortalId;
  @Input() requestModesUrl: string;
  @Input() formGroup: FormGroup;
  controlName = RequestModeControlName;

  constructor(public requestModeService: RequestModeService) {
    super();
  }

  ngOnInit(): void {
    this.fetchRequestModes();
  }

  fetchRequestModes(): void {
    this.requestModeService
      .getModes(this.portalId, this.requestModesUrl)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((modes) => {
        this.requestModes = modes;
        this.setValueWhenIsOneMode();
      });
  }

  setValueWhenIsOneMode(): void {
    const formControl = this.getRequestModeFormControl();
    if (this.requestModes.length === 1) {
      formControl.setValue(this.requestModes[0].id);
    }
  }

  isRequestModeFormControlValid(): boolean {
    return this.getRequestModeFormControl().valid;
  }

  getRequestModeFormControl(): AbstractControl {
    return this.formGroup.get(this.controlName.RequestMode);
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }
}
